import { request, type RequestOptions } from '@/utils/request'

export interface PixelValidateResult {
  id: string
  isValid: boolean
  error?: string
  detail?: {
    callback?: string
    response?: { status: string }
    status?: number
  }
}

export interface PixelValidateResponse {
  platform: string
  isValid: boolean
  mode: string
  results: PixelValidateResult[]
  message: string
}

export interface PixelValidateRequest {
  platform: string
  config: Record<string, unknown>
  testAdId: string
}

export async function validatePixel(
  body: PixelValidateRequest,
  options: RequestOptions = {}
) {
  const res = (await request<PixelValidateResponse>('/api/shops/pixel/validate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...options,
  })) as unknown as PixelValidateResponse

  return res
}
